export enum EUserRoles {
  PHONE_OPERATOR = 4,
  SUPER_ADMIN = 3,
  ACCOUNTANT = 2,
  BOSS = 1,
}

export enum EUserSmallRoles {
  MANAGER = 2,
  CLOSER = 1,
}
